import { Pipe, PipeTransform } from '@angular/core';
import { Util } from '../util';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'parseDate',
})
export class ParseDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: any, args?: any): any {
    return this.datePipe.transform(Util.parseDate(value));
  }
}
